import * as THREE from 'three';
import { G, M, TINT, glowMat, mesh, mergeBones, stages, boneG } from './kit';
/* ============================================================
   ARMILLA 渾儀 —— BOSS・不可能幾何
   ============================================================

   剪影：七環七軸・互不對齊
   階段：'P1 軸對齊・像精密儀器','P2 軸各自漂移・儀器壞了','P3 環互相穿透・剛體做不到的事'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-20 ARMILLA 渾儀 ── 七個環，七個不對齊的軸。
   P1 軸大致對齊，看起來像一具精密儀器 —— 這是它最像機械的時候。
   P2 軸各自漂移，儀器壞了。
   P3 環的半徑互相交錯，兩個實心環直接穿過對方 ——
      這是剛體幾何做不到的事，也是這隻存在的全部理由。 */
var ARN = 7;
export function buildArmilla(){
  var GLV = glowMat(TINT.vio.hex, 2.4);
  var root = new THREE.Group(), rings = [], i;
  var hub = boneG(root, 0, 4.20, 0);
  var vd = mesh(G.oct, M.void, [1.40,1.40,1.40], [0,0,0]);
  vd.userData.noMerge = 1; hub.add(vd);
  var cm = mesh(G.oct, GLV, [0.90,0.90,0.90], [0,0,0]);
  cm.userData.noMerge = 1; hub.add(cm);
  for (i = 0; i < ARN; i++){
    var rg = boneG(hub, 0, 0, 0);
    var d = 8.20 - i*0.62;
    rg.add(mesh(G.tor, i % 2 ? M.armor : M.dark, [d, d, 0.44], [0,0,0]));
    rg.add(mesh(G.box, M.trim, [d*0.96, 0.20, 0.20], [0,0,0]));
    if (i % 3 === 0){
      var gm = mesh(G.box, GLV, [0.20, d*0.94, 0.16], [0,0,0]);
      gm.userData.noMerge = 1; rg.add(gm);
    }
    rings.push({rg:rg, i:i, d:d});
  }
  root.userData.rig = {hub:hub, rings:rings, vd:vd, cm:cm, GLV:GLV};
  return mergeBones(root);
}
export function updArmilla(rig, o, dt){
  stages(rig, o, dt, 1.5);
  var s1 = rig.s1, s2 = rig.s2, i, R;
  for (i = 0; i < ARN; i++){
    R = rig.rings[i];
    var drift = s1 * (0.9 + 0.5*Math.sin(i*2.1));
    R.rg.rotation.x = i*0.14 + drift*Math.sin(o.t*0.4 + i*1.7) + s2*Math.sin(o.t*0.9 + i);
    R.rg.rotation.y = i*0.09 + drift*Math.cos(o.t*0.33 + i*2.3) + s2*Math.cos(o.t*0.7 + i*2);
    R.rg.rotation.z += dt*(0.30 + 0.22*i)*(i % 2 ? 1 : -1)*(1 + 1.8*s2);
    /* 三階段：半徑往中間擠，環開始互相穿透 */
    var k = 1 - s2*(0.55 - 0.055*i);
    R.rg.scale.set(k, k, 1);
    R.rg.position.x = s2*Math.sin(o.t*0.6 + i*1.3)*1.30;
    R.rg.position.y = s2*Math.cos(o.t*0.5 + i*0.8)*1.30;
  }
  rig.hub.position.y = 4.20 + 0.26*Math.sin(o.t*0.6);
  rig.vd.scale.setScalar(1 + 0.5*s1 + 1.4*s2);
  rig.cm.scale.setScalar(1 + 0.20*Math.sin(o.t*3) + 1.1*o.tel + 0.6*s2);
  rig.GLV.emissiveIntensity = 2.4 + 2.6*o.tel + 5*o.atk*(1-o.atk) + 1.6*s2;
}